import { TweenMax } from 'gsap';
import css from './index.module.scss';
import {
    EFAirFryerPC,
    EFCoffeeMakerPC,
    EFElectircDrillsPC,
    EFMicrowaveOvenPC,
    EFElectricHeaterPC,
    EFElectircFryPanPC,
    EFHairDryerPC,
    EFElectricKettlePC,
} from '@/components/UI/svg/xboost';
import { useGlobal } from '@/utils/useGlobal';
import { CanvasKeyFrames } from '@/utils/canvaskeyframes';
import { handleDynamicPath } from '@/utils/handleDynamicPath';

export default function BIcons() {
    const { useLang, useEffect } = useGlobal();
    const { t } = useLang('xboost');
    const xboostIcons = [
        {
            id: 1,
            icon: <EFAirFryerPC />,
            title: t('sec2_icon1_title'),
            num: t('sec2_icon1_num'),
            unit: t('sec2_icon_unit'),
        },
        {
            id: 2,
            icon: <EFCoffeeMakerPC />,
            title: t('sec2_icon2_title'),
            num: t('sec2_icon2_num'),
            unit: t('sec2_icon_unit'),
        },
        {
            id: 3,
            icon: <EFElectircDrillsPC />,
            title: t('sec2_icon3_title'),
            num: t('sec2_icon3_num'),
            unit: t('sec2_icon_unit'),
        },
        {
            id: 4,
            icon: <EFMicrowaveOvenPC />,
            title: t('sec2_icon4_title'),
            num: t('sec2_icon4_num'),
            unit: t('sec2_icon_unit'),
        },
        {
            id: 5,
            icon: <EFElectricHeaterPC />,
            title: t('sec2_icon5_title'),
            num: t('sec2_icon5_num'),
            unit: t('sec2_icon_unit'),
        },
        {
            id: 6,
            icon: <EFElectircFryPanPC />,
            title: t('sec2_icon6_title'),
            num: t('sec2_icon6_num'),
            unit: t('sec2_icon_unit'),
        },
        {
            id: 7,
            icon: <EFHairDryerPC />,
            title: t('sec2_icon7_title'),
            num: t('sec2_icon7_num'),
            unit: t('sec2_icon_unit'),
        },
        {
            id: 8,
            icon: <EFElectricKettlePC />,
            title: t('sec2_icon8_title'),
            num: t('sec2_icon8_num'),
            unit: t('sec2_icon_unit'),
        },
    ];

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        // title文字动画
        new ScrollMagic.Scene({
            triggerElemnt: '.B_icons .title',
            triggerHook: 1,
            offset: 400,
            duration: 200,
        })
            .setTween(
                TweenMax.fromTo(
                    '.B_icons .title',
                    0.5,
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                    },
                ),
            )
            .addTo(controller);

        // text文字动画
        new ScrollMagic.Scene({
            triggerElemnt: '.B_icons .text',
            triggerHook: 1,
            offset: 500,
            duration: 300,
        })
            .setTween(
                TweenMax.fromTo(
                    '.B_icons .text',
                    0.5,
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                    },
                ),
            )
            .addTo(controller);

        // icon元素动画
        new ScrollMagic.Scene({
            triggerElemnt: '.B_icons .iconBox',
            triggerHook: 1,
            offset: 700,
            duration: 300,
        })
            .setTween(
                TweenMax.fromTo(
                    '.B_icons .iconBox',
                    0.5,
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                    },
                ),
            )
            .addTo(controller);

        // memo元素动画
        new ScrollMagic.Scene({
            triggerElemnt: '.B_icons .memo',
            triggerHook: 1,
            offset: 700,
            duration: 100,
        })
            .setTween(
                TweenMax.fromTo(
                    '.B_icons .memo',
                    0.5,
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                    },
                ),
            )
            .addTo(controller);
    }, []);

    // // 动画: 根据滑动值设置背景视频播放进度
    // // JSアニメ：スクロール進歩によってビデオをフレームつづ放送
    // useEffect(() => {
    //     const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042
    //     const scene = new ScrollMagic.Scene({
    //         triggerElement: '.B_icons',
    //         triggerHook: 'onEnter',
    //         offset: (layoutH / 4) * 3,
    //         duration: (layoutH / 4) * 1,
    //     })
    //     scene.on('progress', (_self: any) => {
    //         window.requestAnimationFrame(function () {
    //             if (videoRef && videoRef.current) {
    //                 videoRef.current.currentTime = _self?.progress * videoRef.current.duration || 0
    //             }
    //         })
    //     })
    //     scene.addTo(controller)
    // }, [])

    // 序列帧-1 section-2
    const imgCount = 79;
    let canvasFrames1: any;
    const loadImage1 = (imageCount: number) => {
        const imageEleArr: any[] = [];
        return new Promise((resolve, reject) => {
            let loadImageCount = 0;
            for (let i = 0; i < imageCount; i++) {
                const imageEle = new window.Image();
                imageEleArr.push(imageEle);
                imageEle.onload = function () {
                    loadImageCount++;
                    if (loadImageCount >= imageCount) {
                        // 此时图片全部加载完成
                        resolve(imageEleArr);
                    }
                };
                imageEle.onerror = reject;
                const strIndex = `00${i}`.slice(-2);
                imageEle.src = handleDynamicPath(`/media/x-boost/pc/animation/section02/x-boost_p2_web_000${strIndex}.jpg`);
            }
        });
    };

    useEffect(() => {
        // 提前 loadImage
        const container = document.querySelector('#canvas-frames1');
        if (!container) return;
        loadImage1(imgCount).then((imgArr) => {
            canvasFrames1 = new CanvasKeyFrames(container, 'array', imgArr, {
                width: '100%',
                height: '100%',
                fps: 30,
            });
        });
    }, []);

    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
        // 滚动scroll播放
        const scene1 = new ScrollMagic.Scene({
            triggerElement: '.xboost .B_icons',
            triggerHook: 1,
            offset: 600,
            duration: layoutH - 200,
        });
        scene1.on('progress', (_self: any) => {
            const currentFrame = Math.floor(_self?.progress * (imgCount - 1));
            canvasFrames1?.goto(currentFrame);
        });
        scene1.addTo(controller);
    }, []);

    return (
        <div className={`B_icons ${css.B_icons}`}>
            <div className="innerBox">
                <div className="videoBox">
                    {/* <video
                        ref={videoRef}
                        src="/video/xboost/02_bg.mp4"
                        className="bg_video"
                        width={'100%'}
                        height={'100%'}
                        muted
                        // autoPlay
                        // loop
                        preload="auto"
                        playsInline
                    /> */}
                    <div className="video-wrapper video2" id="canvas-frames1"></div>
                </div>
                <div className="textBox">
                    <p className="title">{t('section_2_title')}</p>
                    <p className="text">{t('section_2_desc')}</p>
                    <div className="iconBox">
                        {xboostIcons?.map((icon: any) => (
                            <div className="iconItem" key={icon?.id}>
                                <div className="icon">{icon?.icon}</div>
                                <p className="name">{icon?.title}</p>
                                <div className="power">
                                    <span className="num">{icon?.num}</span>
                                    <span className="unit">{icon?.unit}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                    <p className="memo">{t('sec2_memo')}</p>
                </div>
            </div>
        </div>
    );
}
